// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Trade = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 16}
    height={size ?? 16}
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" d="m11 9 2 2-2 2M3 11h10M5 7 3 5l2-2M13 5H3" />
  </svg>
);
const ForwardRef = forwardRef(Trade);
export default ForwardRef;
